import { chakra, forwardRef, ImageProps } from "@chakra-ui/react";
import logo from "assets/logo.svg";

export const RiverviewLogo = forwardRef<ImageProps, "img">((props, ref) => {
  return <chakra.img src={logo} ref={ref} {...props} />;
});
